export default {
  init: process.env.BASE_URL + '/api/modules/in_tanabata/index',
  submit: process.env.BASE_URL + '/api/modules/in_tanabata/submit',
  getSumPrize: process.env.BASE_URL + '/api/modules/in_tanabata/get_consolation_prize',
  awardList: process.env.BASE_URL + '/api/modules/in_tanabata/award_list',
}